module.exports = __webpack_public_path__ + "img/concat.6be84d3e.png";